import React from 'react';
import '../../IntegrationBaseComponent.scss';
import css from './FacebookAdsIntegrations.module.css';
import Select from 'antd/es/select';

import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { useConnectionsTableActions } from '@mm/state/modules/connectionsTableState/actions';
import { LinkOutlined } from '@ant-design/icons';
import { useViewActions } from '@mm/state/actions/viewActions';
import { renderAdAccountName } from './use-ad-account';
import AdAccountModel from '@mm/state/model/AdAccountModel';
import { useSelector } from 'react-redux';
import { hasConnectedRealFacebookPageSelector } from '@mm/state/selectors/userSelector';
import { StoreState } from '@mm/state/store-interfaces';
import { SlideOutMenuState } from '@mm/state/interfaces/view';
import { hasFBOauthTokensSelector } from '@mm/state/selectors/fbOauthTokensSelectors';
import { FacebookAdsConnect } from './FacebookAdsConnect';
import { ConnectPageWarning } from 'src/modules/permissions/ConnectPageWarning/ConnectPageWarning';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { Help } from '../KlaviyoIntegrations/KlaviyoHelpLink';

type Props = {
  count: number;
  onConnectAccountClick?: () => void;
  className?: string;
  name?: string;
  adAccounts?: AdAccountModel[];
  selectedAdAccount?: AdAccountModel;
  onSelectedAdAccountChange?: (adAccount: AdAccountModel) => void;
  onPageConnectSuccess?: () => void;
};

export const allOption = {
  id: 'all',
  value: 'all',
  label: 'All',
  remoteId: undefined,
};

export const FacebookAdsIntegrationsHeader = (props: Props) => {
  const isUserPageConnected = useSelector(hasConnectedRealFacebookPageSelector);
  const hasFBOauthTokens = useSelector(hasFBOauthTokensSelector);
  const hasFBConnection = isUserPageConnected || hasFBOauthTokens;

  const {
    count,
    name,
    selectedAdAccount,
    adAccounts = [],
    onSelectedAdAccountChange,
    onPageConnectSuccess,
  } = props;

  const { setActiveIntegration } = useConnectionsTableActions();

  const { showSlideoutMenu } = useViewActions();

  const slideouts = useSelector<StoreState, SlideOutMenuState>(
    state => state.view.slideoutMenu,
  );

  const addNew = async () => {
    showSlideoutMenu('fbAdsIntegrationEditor');
  };

  const onClickAddNew = () => {
    addNew();
    setActiveIntegration(name);
  };

  return (
    <div className="integrations__header-actions">
      <div style={{ marginLeft: 'auto' }}>
        <Help
          link={
            hasFBConnection
              ? 'https://customers.ai/help/l/en/article/huh4yxem6j-how-to-activate-restore-to-retarget-your-audience'
              : 'https://customers.ai/help/l/en/article/pd67p9pfho-connecting-facebook'
          }
          text="Help Center"
        />
      </div>

      {!hasFBConnection ? (
        <FacebookAdsConnect className="facebook-login-button integrations__header-add-button-secondary" />
      ) : (
        <div className={css.headerActions}>
          <div className={css.adAccount}>
            {selectedAdAccount?.id && <span>Ad Account:</span>}

            {!!slideouts.length && (
              <Select
                className={css.select}
                placeholder="Ad Account"
                options={[
                  allOption,
                  ...adAccounts.map(v => ({
                    value: v.id,
                    label: renderAdAccountName(v),
                    ...v,
                  })),
                ]}
                onClick={e => {
                  e.stopPropagation();
                }}
                value={selectedAdAccount?.id}
                onChange={(v, opt) => {
                  onSelectedAdAccountChange?.(opt as AdAccountModel);
                }}
                getPopupContainer={trigger => trigger.parentNode as HTMLElement}
              />
            )}
          </div>
          <div className={css.headerStatus}>
            <div className="integrations__header-status">
              <LinkOutlined className="integrations__header-status-icon" />
              <div className="integrations__header-status-count">{count}</div>
              Synced Audiences
            </div>
            <PrimaryButton
              className="integrations__header-add-button-secondary"
              onClick={e => {
                e?.stopPropagation();
                onClickAddNew();
              }}
              color={ButtonColor.secondaryBlue}
            >
              Create Facebook Audience
            </PrimaryButton>
          </div>
        </div>
      )}
    </div>
  );
};
